// Helper to maintain backward compatibility with REACT_APP_ env vars
// Maps REACT_APP_* to VITE_* for Vite compatibility
export const getEnv = (key: string): string | undefined => {
  // Try VITE_ prefix first (Vite standard)
  const viteKey = key.startsWith('VITE_') ? key : `VITE_${key.replace('REACT_APP_', '')}`
  const env = import.meta.env as Record<string, string | undefined>
  const value = env[viteKey]

  // Fallback to direct access for keys that don't need mapping
  return value || env[key]
}

// Convenience getter for REACT_APP_ prefixed vars
export const getReactAppEnv = (key: string): string | undefined => {
  const cleanKey = key.replace('REACT_APP_', '')
  return getEnv(`VITE_${cleanKey}`)
}
